<template>
	<div class="useri_right">
			<div class="useri_right_pad">
				<div class="userirp_d1"><span></span>快速下单</div>
			</div>
			<div class="useri_right_pad_bot">
				<el-input placeholder="商品名称/订单编号" v-model="input" class="input-with-select">
					<el-button slot="append" icon="el-icon-search">快速下单</el-button>
				</el-input>
			</div>
		</div>
</template>

<script>
	export default {
		data() {

			return {
				input: ""
			}
		},
		computed: {

		},
		watch: {

		},
		created: function() {

		},
		mounted: function() {

		},
		methods: {
			submitForm() {
				console.log(this.form)
			}
		}
	}
</script>